import { Component, Input, OnInit, TemplateRef } from '@angular/core';
import { producedMaterialStatusFlags } from '@app/shared/models';
import { LabelPrintResult, ProducedMaterialPrintLabelInfo } from 'chronos-core-client';
import { AppSettingsQuery } from 'chronos-shared';
import { knownUnitsEnum } from 'projects/chronos-shared/src/lib/models';

@Component({
  selector: 'app-material-label-table',
  templateUrl: './material-label-table.component.html',
  styleUrls: ['./material-label-table.component.scss']
})
export class MaterialLabelTableComponent implements OnInit {
  public readonly COLUMNS = [
    { label: 'LABELS.COLUMN_STATUS', width: '140px' },
    { label: 'LABELS.COLUMN_NUMBER', width: '170px' },
    { label: 'LABELS.COLUMN_QUANTITY', width: '120px' },
    { label: 'LABELS.COLUMN_PRINT', width: '250px' },
    { label: 'LABELS.COLUMN_SSCC', width: '290px' }
  ];

  public readonly STATUS_FLAGS = producedMaterialStatusFlags;

  @Input() public allItemAction: TemplateRef<any>;
  @Input() public perItemAction: TemplateRef<any>;
  @Input() public value: ProducedMaterialPrintLabelInfo[] = [];
  @Input() public isQuantityPerOuterChangeInProgress: { [key: string]: boolean } = {};
  @Input() public slitCount = 0;

  public producedMaterialId?: number;

  public labelPrintResult = LabelPrintResult;
  public isBobbin = false;

  public isQuantityPerOuterValid = false;

  constructor(private appSettingsQuery: AppSettingsQuery) {}

  public ngOnInit(): void {
    if (this.slitCount > 1 && this.appSettingsQuery.getWorkCenter().counterUnitId === knownUnitsEnum.M) {
      const printInfo = this.value.filter((x) => x.printInfo != null);
      if (printInfo?.length) {
        this.isBobbin = true;
      }
    }
  }
}
